import { defineCopy } from '@floorfile/i18n'
import { downtimeCopy } from './copy'

export const downtimeOfflineCopy = defineCopy('downtime', { offlineAction: downtimeCopy.en.offlineAction })
